module.exports = __webpack_public_path__ + "static/planeta_nosotras-5b6caeecd08ec62bfa041562e0754534.png";